import { render } from "./DataGrid.vue?vue&type=template&id=3acc0a35&ts=true"
import script from "./DataGrid.vue?vue&type=script&lang=ts"
export * from "./DataGrid.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__